import styled, { css } from 'styled-components';
import { FlexibleDiv } from '../../styled/common';
import { Breakpoints } from '../../styled/constants';
import { getSafeAreaValue } from '../../styled/theme/helpers/getSafeAreaValue';

export const PhoneBottomContainer = styled(FlexibleDiv)<{
  $isCurrentItemPage?: boolean;
  $isAgencyPage: boolean;
}>`
  align-items: center;
  height: 90px;

  ${({ $isAgencyPage }) =>
    $isAgencyPage &&
    css`
      margin-top: -10px;
      padding: 15px 15px 25px;
      height: 50px;
      background-color: ${({ theme }) => theme.colors.background.primary};
      box-sizing: content-box;

      button {
        height: 48px;
      }
    `}

  ${({ $isCurrentItemPage }) =>
    $isCurrentItemPage &&
    css`
      height: 50px;
      margin: 0;
      padding: 0;
      background-color: ${({ theme }) => theme.colors.background.primary};

      @media (min-width: ${Breakpoints.tablet}px) {
        padding: 0;
        border: none;
        height: max-content;
      }
    `}
`;

export const PhoneBottomWrapper = styled.div<{ $isSticky: boolean }>`
  width: 100%;

  ${({ $isSticky, theme }) =>
    $isSticky &&
    css`
      position: fixed;
      bottom: ${getSafeAreaValue(theme, 'bottom', 10)};
      left: 15px;
      right: 15px;
      width: auto;
      z-index: 3;
    `}
`;

export const buttonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PhoneBottomLink = styled.a<{ $isButtonGreen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  color: ${({ theme }) => theme.colors.text.white};
  line-height: 1;
  font-size: 15px;
  text-decoration: none;
  border-radius: 7px;
  background-color: ${({ theme, $isButtonGreen }) =>
    $isButtonGreen
      ? theme.colors.systemColors.green
      : theme.colors.systemColors.blue};
  box-sizing: border-box;

  &::before {
    content: '';
    background-repeat: no-repeat;
    display: block;
    width: 18px;
    height: 18px;
    margin-right: 10px;
    background-image: url('/static/images/phone_call_white-icon.svg');
  }
`;
